"use client";

import React, { useEffect, useState } from "react";

import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import {
  Lock,
  Info,
  ArrowLeft,
  Clock10,
  RefreshCcw,
  Loader2,
} from "lucide-react";
import { useToast } from "../hooks/use-toast";
import { useQueryClient } from "@tanstack/react-query";
import { refreshBalanceQueries } from "../services/invalidator";
import { refreshPortfolioAndAssets } from "../services/digitalWalletService";
const QuoteDetailsForex = ({
  onBack,
  onConfirm,
  data,
  tradeData,
  orderData,
  typeOfTrade,
  isOrder,
  userId,
  isPostTrade,
  rate,
  onRefresh,
}) => {
  const queryClient = useQueryClient();
  // const feePercentage = parseFloat(data?.feePercentage?.$numberDecimal);
  const feePercentage = 0;
  const amount = parseFloat(data?.totalAmount);
  const currentRate = data?.price;
  const [asset, currency] = data?.pair?.split("-");
  const selectedAsset = asset?.toUpperCase();
  const selectedCurrency = currency?.toUpperCase();
  const [timer, setTimer] = useState(10);
  const [confirmed, setConfirmed] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [isLoadingQuote, setIsLoadingQuote] = useState(false);
  const { toast } = useToast();
  const parsedFiat = parseFloat(amount) || 0;

  const finalCrypto = currentRate > 0 ? parsedFiat / currentRate : 0;

  const serviceFeeCrypto = finalCrypto * feePercentage;

  const finalCryptoAfterFee = finalCrypto - serviceFeeCrypto;

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const displaySubTitle = `at ${selectedAsset}/${selectedCurrency} ${currentRate}`;

  const handleRefresh = () => {
    setIsRefreshing(true);
    setIsLoadingQuote(true);
    onRefresh?.();
  };
  useEffect(() => {
    if (data) {
      setTimer(10);
      setIsRefreshing(false);
      setIsLoadingQuote(false);
    }
  }, [data]);

  const isTimerZero = timer === 0;

  const handleConfirm = () => {
    if (!amount || !selectedAsset || !selectedCurrency) {
      alert("Order details are incomplete.");
      return;
    }
    setConfirmed(true);
    setTimer(0);
    makeTrade();
  };

  const handleLocalBack = () => {
    onBack();
  };

  const makeTrade = async () => {
    try {
      if (typeOfTrade === "Buy" && !isOrder) {
        const result = "trade made";
        // Refresh portfolio data first, then invalidate/refetch dependent queries
        await refreshPortfolioAndAssets();
        await refreshBalanceQueries(queryClient);
        queryClient.invalidateQueries({ queryKey: ["notifications"] });
        onConfirm(result);
      }
      if (typeOfTrade === "Sell" && !isOrder) {
        const result = "trade made";
        // Refresh portfolio data first, then invalidate/refetch dependent queries
        await refreshPortfolioAndAssets();
        await refreshBalanceQueries(queryClient);
        queryClient.invalidateQueries({ queryKey: ["notifications"] });
        onConfirm(result);
      }
      // if (typeOfTrade === "Buy" && isOrder) {
      //   const result = await createOrder(customeOrderData);

      //   onConfirm(result);
      // }
      // if (typeOfTrade === "Sell" && isOrder) {

      //   const result = await createOrder(customeOrderData);

      //   onConfirm(result);
      // }
    } catch (error) {
      toast({
        description: `${error}`,
        variant: "eighty",
      });
    }
  };

  return (
    <>
      {isOrder === false && (
        <Card className="w-full bg-white !shadow-none rounded-2xl">
          <div className="text-center px-6 pt-8">
            <h2 className="text-3xl font-bold text-gray-800">
              {(() => {
                const decimals = selectedAsset === "BTC" ? 6 : 2;
                return tradeData?.incomingAmount?.toFixed(decimals);
              })()}
            </h2>
            <p className="text-sm text-gray-500 mt-1">{displaySubTitle}</p>
          </div>

          <CardContent className="px-6 mt-6">
            <h3 className="text-base font-semibold text-gray-700 mb-3">
              Transaction details
            </h3>

            <div className="border rounded-lg divide-y">
              <div className="p-4 flex justify-between">
                <span className="text-sm text-gray-700">
                  {typeOfTrade === "Buy" ? "Pay with" : "Sell for"}
                </span>
                <span className="text-sm font-medium text-gray-800">
                  {selectedCurrency}
                </span>
              </div>
              <div className="p-4 flex justify-between">
                <span className="text-sm text-gray-700">Deposit to</span>
                <span className="text-sm font-medium text-gray-800">
                  Digital Wallet
                </span>
              </div>

              {typeOfTrade === "Buy" && (
                <div className="p-4 flex justify-between">
                  <span className="text-sm text-gray-700">You receive</span>
                  <span className="text-sm font-medium text-gray-800">
                    {data?.formattedTotalAmount}
                  </span>
                </div>
              )}

              {typeOfTrade === "Sell" && (
                <div className="p-4 flex justify-between">
                  <span className="text-sm text-gray-700">You receive</span>
                  <span className="text-sm font-medium text-gray-800">
                    {data?.formattedAmountReceived}
                  </span>
                </div>
              )}
              <div className="p-4 flex justify-between items-center">
                <span className="flex items-center gap-1 text-sm text-gray-700">
                  Service charge
                  <Info size={14} className="text-gray-500" />
                </span>
                <span className="text-sm font-medium text-gray-800">
                  {/* {data?.formattedServiceFee} (
                  {data?.feePercentage?.$numberDecimal + "%"}) */}
                  0 (0%)
                </span>
              </div>
              {typeOfTrade === "Buy" && (
                <div className="p-4 flex justify-between">
                  <span className="text-sm text-gray-700">Total cost</span>
                  <span className="text-sm font-bold text-gray-900">
                    {data?.formattedAmountReceived}
                  </span>
                </div>
              )}
              {typeOfTrade === "Sell" && (
                <div className="p-4 flex justify-between">
                  <span className="text-sm text-gray-700">Total cost</span>
                  <span className="text-sm font-bold text-gray-900">
                    {data?.formattedTotalAmount}
                  </span>
                </div>
              )}
            </div>
          </CardContent>

          <div className="flex justify-between w-full">
            <div className="px-6 py-6 flex items-center w-1/2">
              <Button
                variant="ghost"
                onClick={handleLocalBack}
                className="w-10 h-10 mr-10 rounded-full p-0 flex items-center justify-center border border-gray-200 hover:bg-gray-100"
              >
                <ArrowLeft size={20} className="text-gray-700" />
              </Button>
              <div className="text-xs text-gray-500 flex items-center gap-1">
                <Clock10
                  size={18}
                  className="bg-purple-500 border rounded-full text-white font-bold"
                />
                <span>Your quote will expire in:</span>
                <span className="font-bold text-rose-600">{timer}s</span>
              </div>
            </div>

            <div className="flex items-center justify-end mr-10 w-1/2 gap-4">
              {isTimerZero && (
                <Button
                  onClick={handleRefresh}
                  disabled={confirmed || isRefreshing}
                  className="py-3 px-12 text-sm font-bold text-white rounded-full bg-gradient-to-tr from-purple-500 to-rose-500 hover:opacity-90 flex items-center gap-2"
                >
                  {isLoadingQuote ? (
                    <Loader2 className="animate-spin w-4 h-4" />
                  ) : (
                    <RefreshCcw className="mr-2" />
                  )}
                  {isLoadingQuote ? "Refreshing..." : "Refresh"}
                </Button>
              )}
              <Button
                onClick={handleConfirm}
                disabled={isTimerZero || confirmed}
                className={`py-3 px-10 text-sm font-bold text-white rounded-full ${
                  isTimerZero
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-gradient-to-tr from-purple-500 to-rose-500 hover:opacity-90"
                }`}
              >
                Confirm
              </Button>
            </div>
          </div>

          <div className="flex items-center justify-center gap-1 text-sm text-gray-500 pb-6">
            <Lock size={12} />
            <p>Secured by 80Eight</p>
          </div>
        </Card>
      )}
      {typeOfTrade === "Buy" && isOrder === true && (
        <Card className="w-full bg-white !shadow-none rounded-2xl">
          <div className="text-center px-6 pt-8">
            <h2 className="text-3xl font-bold text-gray-800">
              {data?.formattedAmountReceived}
            </h2>
            <p className="text-sm text-gray-500 mt-1">{displaySubTitle}</p>
          </div>

          <CardContent className="px-6 mt-6">
            <h3 className="text-base font-semibold text-gray-700 mb-3">
              Transaction details
            </h3>

            <div className="border rounded-lg divide-y">
              <div className="p-4 flex justify-between">
                <span className="text-sm text-gray-700">
                  {typeOfTrade === "Buy" ? "Pay with" : "Sell for"}
                </span>
                <span className="text-sm font-medium text-gray-800">
                  {selectedCurrency}
                </span>
              </div>
              <div className="p-4 flex justify-between">
                <span className="text-sm text-gray-700">Deposit to</span>
                <span className="text-sm font-medium text-gray-800">
                  Digital Wallet
                </span>
              </div>

              {typeOfTrade === "Buy" && (
                <div className="p-4 flex justify-between">
                  <span className="text-sm text-gray-700">You receive</span>
                  <span className="text-sm font-medium text-gray-800">
                    {(() => {
                      const decimals = selectedAsset === "BTC" ? 6 : 2;
                      return finalCryptoAfterFee.toFixed(decimals);
                    })()}{" "}
                    {selectedAsset}
                  </span>
                </div>
              )}
              {typeOfTrade === "Buy" && (
                <div className="p-4 flex justify-between">
                  <span className="text-sm text-gray-700">
                    Current {selectedAsset} price
                  </span>
                  <span className="text-sm font-medium text-gray-800">
                    R {rate?.toFixed(2)}
                  </span>
                </div>
              )}
              {typeOfTrade === "Buy" && (
                <div className="p-4 flex justify-between">
                  <span className="text-sm text-gray-700">Target Price</span>
                  <span className="text-sm font-medium text-gray-800">
                    R {`${orderData?.targetPrice}`}
                  </span>
                </div>
              )}

              {typeOfTrade === "Sell" && (
                <div className="p-4 flex justify-between">
                  <span className="text-sm text-gray-700">You receive</span>
                  <span className="text-sm font-medium text-gray-800">
                    {parsedFiat.toFixed(2)} {selectedCurrency}
                  </span>
                </div>
              )}
              <div className="p-4 flex justify-between items-center">
                <span className="flex items-center gap-1 text-sm text-gray-700">
                  Service charge
                  <Info size={14} className="text-gray-500" />
                </span>
                <span className="text-sm font-medium text-gray-800">
                  {/* {data?.formattedServiceFee} <br />(
                  {data?.feePercentage?.$numberDecimal + "%"}) */}
                  0 (0%)
                </span>
              </div>
              {typeOfTrade === "Buy" && (
                <div className="p-4 flex justify-between">
                  <span className="text-sm text-gray-700">Total cost</span>
                  <span className="text-sm font-bold text-gray-900">
                    {`R ${parsedFiat.toFixed(2)}`}
                  </span>
                </div>
              )}
              {typeOfTrade === "Sell" && (
                <div className="p-4 flex justify-between">
                  <span className="text-sm text-gray-700">Total cost</span>
                  <span className="text-sm font-bold text-gray-900">
                    {`R ${serviceFeeCrypto.toFixed(2)}`}
                  </span>
                </div>
              )}
            </div>
          </CardContent>

          <div className="flex justify-between w-full">
            <div className="px-6 py-6 flex items-center w-1/2">
              <Button
                variant="ghost"
                onClick={handleLocalBack}
                className="w-10 h-10 mr-10 rounded-full p-0 flex items-center justify-center border border-gray-200 hover:bg-gray-100"
              >
                <ArrowLeft size={20} className="text-gray-700" />
              </Button>
              <div className="text-xs text-gray-500 flex items-center gap-1">
                <Clock10
                  size={18}
                  className="bg-purple-500 border rounded-full text-white font-bold"
                />
                <span>Your quote will expire in:</span>
                <span className="font-bold text-rose-600">{timer}s</span>
              </div>
            </div>

            <div className="flex items-center justify-end mr-10 w-1/2 gap-4">
              {isTimerZero && (
                <Button
                  onClick={handleRefresh}
                  disabled={confirmed || isRefreshing}
                  className="py-3 px-12 text-sm font-bold text-white rounded-full bg-gradient-to-tr from-purple-500 to-rose-500 hover:opacity-90 flex items-center gap-2"
                >
                  {isLoadingQuote ? (
                    <Loader2 className="animate-spin w-4 h-4" />
                  ) : (
                    <RefreshCcw className="mr-2" />
                  )}
                  {isLoadingQuote ? "Refreshing..." : "Refresh"}
                </Button>
              )}
              <Button
                onClick={handleConfirm}
                disabled={isTimerZero || confirmed}
                className={`py-3 px-10 text-sm font-bold text-white rounded-full ${
                  isTimerZero
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-gradient-to-tr from-purple-500 to-rose-500 hover:opacity-90"
                }`}
              >
                Confirm
              </Button>
            </div>
          </div>

          <div className="flex items-center justify-center gap-1 text-sm text-gray-500 pb-6">
            <Lock size={12} />
            <p>Secured by 80Eight</p>
          </div>
        </Card>
      )}
      {typeOfTrade === "Sell" && isOrder === true && (
        <Card className="w-full bg-white !shadow-none rounded-2xl">
          <div className="text-center px-6 pt-8">
            <h2 className="text-3xl font-bold text-gray-800">
              {data?.formattedTotalAmount}
            </h2>
            <p className="text-sm text-gray-500 mt-1">{displaySubTitle}</p>
          </div>

          <CardContent className="px-6 mt-6">
            <h3 className="text-base font-semibold text-gray-700 mb-3">
              Transaction details
            </h3>

            <div className="border rounded-lg divide-y">
              <div className="p-4 flex justify-between">
                <span className="text-sm text-gray-700">
                  {typeOfTrade === "Buy" ? "Pay with" : "Sell for"}
                </span>
                <span className="text-sm font-medium text-gray-800">
                  {selectedCurrency}
                </span>
              </div>
              <div className="p-4 flex justify-between">
                <span className="text-sm text-gray-700">Deposit to</span>
                <span className="text-sm font-medium text-gray-800">
                  Digital Wallet
                </span>
              </div>

              {typeOfTrade === "Sell" && (
                <div className="p-4 flex justify-between">
                  <span className="text-sm text-gray-700">
                    Current {selectedAsset} price
                  </span>
                  <span className="text-sm font-medium text-gray-800">
                    R {rate.toFixed(2)}
                  </span>
                </div>
              )}
              {typeOfTrade === "Sell" && (
                <div className="p-4 flex justify-between">
                  <span className="text-sm text-gray-700">Target Price</span>
                  <span className="text-sm font-medium text-gray-800">
                    {data?.price}
                  </span>
                </div>
              )}

              <div className="p-4 flex justify-between items-center">
                <span className="flex items-center gap-1 text-sm text-gray-700">
                  Service charge
                  <Info size={14} className="text-gray-500" />
                </span>
                <span className="text-sm font-medium text-gray-800">
                  {/* {data?.formattedServiceFee} <br />(
                  {data?.feePercentage?.$numberDecimal + "%"}) */}
                  0 (0%)
                </span>
              </div>
              {typeOfTrade === "Sell" && (
                <div className="p-4 flex justify-between">
                  <span className="text-sm text-gray-700">Total cost</span>
                  <span className="text-sm font-bold text-gray-900">
                    {data?.formattedTotalAmount}
                  </span>
                </div>
              )}
            </div>
          </CardContent>

          <div className="flex justify-between w-full">
            <div className="px-6 py-6 flex items-center w-1/2">
              <Button
                variant="ghost"
                onClick={handleLocalBack}
                className="w-10 h-10 mr-10 rounded-full p-0 flex items-center justify-center border border-gray-200 hover:bg-gray-100"
              >
                <ArrowLeft size={20} className="text-gray-700" />
              </Button>
              <div className="text-xs text-gray-500 flex items-center gap-1">
                <Clock10
                  size={18}
                  className="bg-purple-500 border rounded-full text-white font-bold"
                />
                <span>Your quote will expire in:</span>
                <span className="font-bold text-rose-600">{timer}s</span>
              </div>
            </div>

            <div className="flex items-center justify-end mr-10 w-1/2 gap-4">
              {isTimerZero && (
                <Button
                  onClick={handleRefresh}
                  disabled={confirmed || isRefreshing}
                  className="py-3 px-12 text-sm font-bold text-white rounded-full bg-gradient-to-tr from-purple-500 to-rose-500 hover:opacity-90 flex items-center gap-2"
                >
                  {isLoadingQuote ? (
                    <Loader2 className="animate-spin w-4 h-4" />
                  ) : (
                    <RefreshCcw className="mr-2" />
                  )}
                  {isLoadingQuote ? "Refreshing..." : "Refresh"}
                </Button>
              )}
              <Button
                onClick={handleConfirm}
                disabled={isTimerZero || confirmed}
                className={`py-3 px-10 text-sm font-bold text-white rounded-full ${
                  isTimerZero
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-gradient-to-tr from-purple-500 to-rose-500 hover:opacity-90"
                }`}
              >
                Confirm
              </Button>
            </div>
          </div>

          <div className="flex items-center justify-center gap-1 text-sm text-gray-500 pb-6">
            <Lock size={12} />
            <p>Secured by 80Eight</p>
          </div>
        </Card>
      )}
    </>
  );
};

export default QuoteDetailsForex;
